import React, { useContext } from 'react';
import { Route, Switch, Redirect, useParams } from 'react-router-dom';
import { useBreakpoint } from 'hooks';
import { Page } from 'components';
import { AuthContext } from 'contexts';
import { DocumentsContextProvider } from './DocumentsContext';
import DocumentsTabs from './DocumentsTabs';
import DocumentsBreadcrumb from './DocumentsBreadcrumb';
import DocumentActions from './DocumentActions';
import DocumentsAside from './DocumentsAside';
import DocumentsTable from './DocumentsTable';
import DocumentViewer from './DocumentViewer';
import DocumentHistory from './DocumentHistory';

const documentListPath = '/listing/:listingId/documents';
const documentViewerPath = '/listing/:listingId/documents/:documentId';

const DocumentsPage: React.FC = () => {
  const { hasFeature, hasLimitedAccess } = useContext(AuthContext);
  const { md } = useBreakpoint();
  const { documentId } = useParams<Record<string, string>>();

  if (!hasFeature('CREATE_LISTING')) {
    return <Redirect to="/feature-missing" />;
  }

  return (
    <DocumentsContextProvider>
      <Page
        overAlertVariant={hasLimitedAccess ? 'noAccess' : undefined}
        type={documentId ? 'hollow' : 'filled'}
        title="Documents"
        overTitle={<DocumentsBreadcrumb />}
        showBackButton
        fillScreenHeight
        headerExtra={documentId && <DocumentActions />}
        subHeader={
          <Route
            exact
            path={documentListPath}
            render={() => <DocumentsTabs hasLimitedAccess={hasLimitedAccess} />}
          />
        }
        aside={md && documentId && <DocumentsAside />}
        asidePlacement="right"
        asideWidth={md ? 250 : 0}
      >
        <Switch>
          <Route exact path={documentListPath} component={DocumentsTable} />
          <Route exact path={documentViewerPath} component={DocumentViewer} />
        </Switch>
      </Page>
      <DocumentHistory />
    </DocumentsContextProvider>
  );
};

export default DocumentsPage;
